import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"color":"primary","rbt-target":"createWorkspace","large":""},on:{"click":_vm.navigateWorkspaceCreation}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("action_add")]),_c('span',[_vm._v(_vm._s(_vm.$t("MyWorkspaces.button.createNewWorkspace")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }